export const categories = [
  { label: "Women's Health", count: 3 },
  { label: 'Stress & Nervous System', count: 2 },
  { label: 'Immune Support', count: 2 },
  { label: 'Digestive Health', count: 2 },
  { label: 'General Wellness', count: 2 },
]

export const products = [
  {
    n: '01',
    name: 'Womb Harmony Tincture',
    category: "Women's Health",
    desc: 'A targeted herbal tincture supporting uterine health, hormonal balance, and relief from heavy or painful periods.',
    format: 'Tincture · 50ml',
  },
  {
    n: '02',
    name: 'Cycle Support Tea',
    category: "Women's Health",
    desc: 'A carefully blended herbal tea formulated to ease premenstrual tension, cramping, and mood fluctuations throughout the cycle.',
    format: 'Loose Leaf Tea · 50g',
  },
  {
    n: '03',
    name: 'Menopause Ease Blend',
    category: "Women's Health",
    desc: 'A clinical herbal formulation addressing hot flushes, night sweats, mood changes, and sleep disruption during perimenopause and menopause.',
    format: 'Tincture · 100ml',
  },
  {
    n: '04',
    name: 'Calm Mind Tincture',
    category: 'Stress & Nervous System',
    desc: 'An adaptogenic formula supporting the nervous system, reducing stress reactivity, and promoting sustained mental clarity and calm.',
    format: 'Tincture · 50ml',
  },
  {
    n: '05',
    name: 'Adaptogen Restore Tea',
    category: 'Stress & Nervous System',
    desc: 'A restorative herbal tea drawing on ashwagandha, tulsi, and traditional Caribbean nervines to support the body under chronic stress.',
    format: 'Loose Leaf Tea · 50g',
  },
  {
    n: '06',
    name: 'Elderberry & Herb Elixir',
    category: 'Immune Support',
    desc: 'A potent immune-supporting elixir combining elderberry with traditional African and Caribbean healing botanicals for year-round resilience.',
    format: 'Elixir · 100ml',
  },
  {
    n: '07',
    name: 'Immune Boost Tea',
    category: 'Immune Support',
    desc: 'A warming, aromatic blend of immune-modulating herbs used in traditional practice and supported by modern phytotherapy research.',
    format: 'Loose Leaf Tea · 50g',
  },
  {
    n: '08',
    name: 'Digestive Harmony Tincture',
    category: 'Digestive Health',
    desc: 'A comprehensive digestive formula addressing bloating, IBS-like symptoms, sluggish digestion, and gut inflammation.',
    format: 'Tincture · 50ml',
  },
  {
    n: '09',
    name: 'Daily Wellness Blend',
    category: 'General Wellness',
    desc: 'A broad-spectrum wellness tonic formulated to support energy, immunity, and foundational health as part of a daily herbal routine.',
    format: 'Tincture · 100ml',
  },
  {
    n: '10',
    name: 'Vitality Root Tea',
    category: 'General Wellness',
    desc: 'A grounding, mineral-rich herbal tea drawing on roots and barks from African and Caribbean healing traditions for deep nourishment.',
    format: 'Loose Leaf Tea · 50g',
  },
  {
    n: '11',
    name: 'Gut Harmony Tea',
    category: 'Digestive Health',
    desc: 'A gentle, soothing blend for intestinal inflammation, leaky gut support, and the restoration of healthy gut microbiome balance.',
    format: 'Loose Leaf Tea · 50g',
  },
]
